import React from 'react';
import './HeroSection.css';

/**
 * HeroSection - Full-width banner with LOVWhereYouWork graphic
 *
 * Uses the official banner image with team collaboration background
 * Features empowering imagery showing diverse professionals
 */
export function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-content">
        {/* Banner Image */}
        <div className="hero-banner-wrapper">
          <img
            src="/story_images/Lovewhere youworkAITool_v8.png"
            alt="LOVWhereYouWork - AI-Powered Legal Document Analysis"
            className="hero-banner-image"
          />
        </div>
      </div>
    </section>
  );
}
